import { render } from "./textInput.vue?vue&type=template&id=5d5d8cc2&scoped=true&ts=true"
import script from "./textInput.vue?vue&type=script&lang=ts"
export * from "./textInput.vue?vue&type=script&lang=ts"

import "./textInput.vue?vue&type=style&index=0&id=5d5d8cc2&lang=less&scoped=true"

import exportComponent from "D:\\Website desing\\kkiokio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d5d8cc2"]])

export default __exports__